export default __webpack_public_path__ + "static/media/logo-transmissao.1fd0dde7.png";